/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionModuleAdminResponsePaginatedResponse,
  ActionModuleNotificationBaseTriggerModel,
  ActionModuleNotificationGenericMessageTriggerModel,
  ActionModuleNotificationNotifyTriggerModel,
  ActionModuleResponse,
  AdministratorUserModel,
  CompanyAnalysisFileResponsePaginatedResponse,
  CompanyCadoozOverviewModel,
  CompanyInvoiceFileResponsePaginatedResponse,
  CompanyListItemResponsePaginatedResponse,
  CompanyResponse,
  CreateActionModuleRequest,
  CreateAdministratorAccountRequest,
  CreateCompanyRequest,
  CreateDemoCodeRequest,
  CreateVoucherRequest,
  DeleteApiAdministrationAdministratorusersAdministratorUserIdParams,
  DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams,
  DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams,
  DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
  DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams,
  DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams,
  DeleteApiCompaniesCompanyIdMembersParams,
  DeleteApiCompaniesCompanyIdParams,
  DeleteApiDemoCodeDemoCodeParams,
  DemoCodeResponse,
  Duration,
  EmployeeUserWalletBalancesResponse,
  ErrorResponse,
  GetAccountBalanceResponse,
  GetApiAdministrationActionmodulesParams,
  GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams,
  GetApiAdministrationAdministratorusersParams,
  GetApiAdministrationCadoozAccountBalanceParams,
  GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
  GetApiAdministrationCompaniesCompanyIdActionmodulesParams,
  GetApiAdministrationCompaniesCompanyIdWalletTypesParams,
  GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams,
  GetApiAdministrationWalletsWalletIdParams,
  GetApiAdministratorusersAnalysisfilesParams,
  GetApiAdministratorusersInvoicesParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams,
  GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams,
  GetApiCompaniesCompanyIdGroupsParams,
  GetApiCompaniesCompanyIdMembersParams,
  GetApiCompaniesCompanyIdParams,
  GetApiCompaniesPaginatedParams,
  GetApiCompaniesParams,
  GetApiCompaniesVoucheroverviewParams,
  GetApiDemoCodeDemoCodeParams,
  InvoiceCreationRequest,
  InvoiceFileModel,
  LoginSuccessfulResponse,
  OrderVouchersResult,
  PatchApiAdministrationAdministratorusersAdministratorUserIdParams,
  PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
  PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams,
  PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams,
  PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams,
  PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams,
  PatchApiCompaniesCompanyIdParams,
  PermissionAssignmentModel,
  PermissionEntityType,
  PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams,
  PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams,
  PostApiAdministrationAdministratorusersParams,
  PostApiAdministrationCompaniesCompanyIdActionmodulesParams,
  PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams,
  PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams,
  PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams,
  PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams,
  PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams,
  PostApiAdministrationCompaniesCompanyIdVoucherorderParams,
  PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams,
  PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams,
  PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams,
  PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams,
  PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams,
  PostApiAdministratorusersInvoicesCompaniesCompanyIdParams,
  PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams,
  PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams,
  PostApiCompaniesCompanyIdMembersParams,
  PostApiCompaniesParams,
  PostApiDemoCodeParams,
  PostApiVouchersParams,
  ProblemDetails,
  RecalculateTimeQuotaModel,
  RecalculateTimetrackingModel,
  ScheduleDaysDefinitionModel,
  ScheduleDefinitionBaseModel,
  ScheduleMonthDayRangeDefinitionModel,
  ScheduleMonthDefinitionModel,
  ScheduleQuarterDefinitionModel,
  ScheduleTimePeriodsDefinitionModel,
  ScheduleWeekDefinitionModel,
  SetEmployeeUserPasswordRequest,
  ShopModuleType,
  SimpleGroupResponse,
  UpdateActionModuleRequest,
  UpdateAdministratorUserRequest,
  UpdateCompanyRequest,
  UpdateGroupAssignment,
  UserResponse,
  WalletBalancesResponse,
  WalletTypeResponse
} from '../../model';

import { axiosInstance } from '../../axios-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;





const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @deprecated
 */
export const getApiCompaniesCompanyIdGroups = (
    companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<SimpleGroupResponse[]>(
      {url: `/api/companies/${companyId}/groups`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdGroupsQueryKey = (companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams,) => {
    return [
    `/api/companies/${companyId}/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError = ErrorResponse>(companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdGroupsQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>> = ({ signal }) => getApiCompaniesCompanyIdGroups(companyId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>>
export type GetApiCompaniesCompanyIdGroupsQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError = ErrorResponse>(
 companyId: number,
    params: undefined |  GetApiCompaniesCompanyIdGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCompanyIdGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdGroupsQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAdministrationAdministratorusers = (
    params?: GetApiAdministrationAdministratorusersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AdministratorUserModel[]>(
      {url: `/api/administration/administratorusers`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationAdministratorusersQueryKey = (params?: GetApiAdministrationAdministratorusersParams,) => {
    return [
    `/api/administration/administratorusers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationAdministratorusersQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError = unknown>(params?: GetApiAdministrationAdministratorusersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationAdministratorusersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>> = ({ signal }) => getApiAdministrationAdministratorusers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationAdministratorusersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>>
export type GetApiAdministrationAdministratorusersQueryError = unknown


export function useGetApiAdministrationAdministratorusers<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError = unknown>(
 params: undefined |  GetApiAdministrationAdministratorusersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationAdministratorusers<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError = unknown>(
 params?: GetApiAdministrationAdministratorusersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationAdministratorusers<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError = unknown>(
 params?: GetApiAdministrationAdministratorusersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationAdministratorusers<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError = unknown>(
 params?: GetApiAdministrationAdministratorusersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationAdministratorusersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministrationAdministratorusers = (
    createAdministratorAccountRequest?: CreateAdministratorAccountRequest,
    params?: PostApiAdministrationAdministratorusersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AdministratorUserModel>(
      {url: `/api/administration/administratorusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdministratorAccountRequest,
        params, signal
    },
      );
    }




export const getPostApiAdministrationAdministratorusersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>, TError,{data?: CreateAdministratorAccountRequest;params?: PostApiAdministrationAdministratorusersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>, TError,{data?: CreateAdministratorAccountRequest;params?: PostApiAdministrationAdministratorusersParams}, TContext> => {

const mutationKey = ['postApiAdministrationAdministratorusers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>, {data?: CreateAdministratorAccountRequest;params?: PostApiAdministrationAdministratorusersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiAdministrationAdministratorusers(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationAdministratorusersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>>
    export type PostApiAdministrationAdministratorusersMutationBody = CreateAdministratorAccountRequest | undefined
    export type PostApiAdministrationAdministratorusersMutationError = ErrorResponse

    export const usePostApiAdministrationAdministratorusers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>, TError,{data?: CreateAdministratorAccountRequest;params?: PostApiAdministrationAdministratorusersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationAdministratorusers>>,
        TError,
        {data?: CreateAdministratorAccountRequest;params?: PostApiAdministrationAdministratorusersParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationAdministratorusersMutationOptions(options), queryClient);
    }
    export const patchApiAdministrationAdministratorusersAdministratorUserId = (
    administratorUserId: string,
    updateAdministratorUserRequest?: UpdateAdministratorUserRequest,
    params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAdministratorUserRequest,
        params, signal
    },
      );
    }




export const getPatchApiAdministrationAdministratorusersAdministratorUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;data?: UpdateAdministratorUserRequest;params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;data?: UpdateAdministratorUserRequest;params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext> => {

const mutationKey = ['patchApiAdministrationAdministratorusersAdministratorUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>, {administratorUserId: string;data?: UpdateAdministratorUserRequest;params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams}> = (props) => {
          const {administratorUserId,data,params} = props ?? {};

          return  patchApiAdministrationAdministratorusersAdministratorUserId(administratorUserId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAdministrationAdministratorusersAdministratorUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>>
    export type PatchApiAdministrationAdministratorusersAdministratorUserIdMutationBody = UpdateAdministratorUserRequest | undefined
    export type PatchApiAdministrationAdministratorusersAdministratorUserIdMutationError = ErrorResponse

    export const usePatchApiAdministrationAdministratorusersAdministratorUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;data?: UpdateAdministratorUserRequest;params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAdministrationAdministratorusersAdministratorUserId>>,
        TError,
        {administratorUserId: string;data?: UpdateAdministratorUserRequest;params?: PatchApiAdministrationAdministratorusersAdministratorUserIdParams},
        TContext
      > => {
      return useMutation(getPatchApiAdministrationAdministratorusersAdministratorUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiAdministrationAdministratorusersAdministratorUserId = (
    administratorUserId: string,
    params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiAdministrationAdministratorusersAdministratorUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext> => {

const mutationKey = ['deleteApiAdministrationAdministratorusersAdministratorUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>, {administratorUserId: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams}> = (props) => {
          const {administratorUserId,params} = props ?? {};

          return  deleteApiAdministrationAdministratorusersAdministratorUserId(administratorUserId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>>

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdMutationError = ErrorResponse

    export const useDeleteApiAdministrationAdministratorusersAdministratorUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>, TError,{administratorUserId: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserId>>,
        TError,
        {administratorUserId: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiAdministrationAdministratorusersAdministratorUserIdMutationOptions(options), queryClient);
    }
    export const getApiAdministrationAdministratorusersAdministratorUserIdPermissions = (
    administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<PermissionAssignmentModel[]>(
      {url: `/api/administration/administratorusers/${administratorUserId}/permissions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryKey = (administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams,) => {
    return [
    `/api/administration/administratorusers/${administratorUserId}/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError = ErrorResponse>(administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryKey(administratorUserId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>> = ({ signal }) => getApiAdministrationAdministratorusersAdministratorUserIdPermissions(administratorUserId,params, signal);





   return  { queryKey, queryFn, enabled: administratorUserId !== null && administratorUserId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>>
export type GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryError = ErrorResponse


export function useGetApiAdministrationAdministratorusersAdministratorUserIdPermissions<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError = ErrorResponse>(
 administratorUserId: string,
    params: undefined |  GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationAdministratorusersAdministratorUserIdPermissions<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError = ErrorResponse>(
 administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationAdministratorusersAdministratorUserIdPermissions<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError = ErrorResponse>(
 administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationAdministratorusersAdministratorUserIdPermissions<TData = Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError = ErrorResponse>(
 administratorUserId: string,
    params?: GetApiAdministrationAdministratorusersAdministratorUserIdPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationAdministratorusersAdministratorUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationAdministratorusersAdministratorUserIdPermissionsQueryOptions(administratorUserId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName = (
    administratorUserId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}/permissions/${entityType}/${permissionName}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext> => {

const mutationKey = ['postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}> = (props) => {
          const {administratorUserId,entityType,permissionName,params} = props ?? {};

          return  postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName(administratorUserId,entityType,permissionName,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>>

    export type PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationError = ErrorResponse

    export const usePostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>,
        TError,
        {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationOptions(options), queryClient);
    }
    export const deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName = (
    administratorUserId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}/permissions/${entityType}/${permissionName}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext> => {

const mutationKey = ['deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}> = (props) => {
          const {administratorUserId,entityType,permissionName,params} = props ?? {};

          return  deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName(administratorUserId,entityType,permissionName,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>>

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationError = ErrorResponse

    export const useDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionName>>,
        TError,
        {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameParams},
        TContext
      > => {
      return useMutation(getDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameMutationOptions(options), queryClient);
    }
    export const postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId = (
    administratorUserId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    targetEntityId: number,
    params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}/permissions/${entityType}/${permissionName}/${targetEntityId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext> => {

const mutationKey = ['postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}> = (props) => {
          const {administratorUserId,entityType,permissionName,targetEntityId,params} = props ?? {};

          return  postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId(administratorUserId,entityType,permissionName,targetEntityId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>>

    export type PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationError = ErrorResponse

    export const usePostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>,
        TError,
        {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: PostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions(options), queryClient);
    }
    export const deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId = (
    administratorUserId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    targetEntityId: number,
    params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/administratorusers/${administratorUserId}/permissions/${entityType}/${permissionName}/${targetEntityId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext> => {

const mutationKey = ['deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}> = (props) => {
          const {administratorUserId,entityType,permissionName,targetEntityId,params} = props ?? {};

          return  deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId(administratorUserId,entityType,permissionName,targetEntityId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>>

    export type DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationError = ErrorResponse

    export const useDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityId>>,
        TError,
        {administratorUserId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number;params?: DeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiAdministrationAdministratorusersAdministratorUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions(options), queryClient);
    }
    export const getApiAdministrationCadoozAccountBalance = (
    params?: GetApiAdministrationCadoozAccountBalanceParams,
 signal?: AbortSignal
) => {


      return axiosInstance<GetAccountBalanceResponse>(
      {url: `/api/administration/cadooz/account/balance`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationCadoozAccountBalanceQueryKey = (params?: GetApiAdministrationCadoozAccountBalanceParams,) => {
    return [
    `/api/administration/cadooz/account/balance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationCadoozAccountBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError = unknown>(params?: GetApiAdministrationCadoozAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationCadoozAccountBalanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>> = ({ signal }) => getApiAdministrationCadoozAccountBalance(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationCadoozAccountBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>>
export type GetApiAdministrationCadoozAccountBalanceQueryError = unknown


export function useGetApiAdministrationCadoozAccountBalance<TData = Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError = unknown>(
 params: undefined |  GetApiAdministrationCadoozAccountBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCadoozAccountBalance<TData = Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError = unknown>(
 params?: GetApiAdministrationCadoozAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCadoozAccountBalance<TData = Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError = unknown>(
 params?: GetApiAdministrationCadoozAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationCadoozAccountBalance<TData = Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError = unknown>(
 params?: GetApiAdministrationCadoozAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCadoozAccountBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationCadoozAccountBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiDemoCode = (
    createDemoCodeRequest?: CreateDemoCodeRequest,
    params?: PostApiDemoCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<string>(
      {url: `/api/demo/code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDemoCodeRequest,
        params, signal
    },
      );
    }




export const getPostApiDemoCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDemoCode>>, TError,{data?: CreateDemoCodeRequest;params?: PostApiDemoCodeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiDemoCode>>, TError,{data?: CreateDemoCodeRequest;params?: PostApiDemoCodeParams}, TContext> => {

const mutationKey = ['postApiDemoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDemoCode>>, {data?: CreateDemoCodeRequest;params?: PostApiDemoCodeParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiDemoCode(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDemoCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDemoCode>>>
    export type PostApiDemoCodeMutationBody = CreateDemoCodeRequest | undefined
    export type PostApiDemoCodeMutationError = ErrorResponse

    export const usePostApiDemoCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDemoCode>>, TError,{data?: CreateDemoCodeRequest;params?: PostApiDemoCodeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDemoCode>>,
        TError,
        {data?: CreateDemoCodeRequest;params?: PostApiDemoCodeParams},
        TContext
      > => {
      return useMutation(getPostApiDemoCodeMutationOptions(options), queryClient);
    }
    export const getApiDemoCodeDemoCode = (
    demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<DemoCodeResponse>(
      {url: `/api/demo/code/${demoCode}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiDemoCodeDemoCodeQueryKey = (demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams,) => {
    return [
    `/api/demo/code/${demoCode}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiDemoCodeDemoCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError = ErrorResponse>(demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDemoCodeDemoCodeQueryKey(demoCode,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>> = ({ signal }) => getApiDemoCodeDemoCode(demoCode,params, signal);





   return  { queryKey, queryFn, enabled: demoCode !== null && demoCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDemoCodeDemoCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>>
export type GetApiDemoCodeDemoCodeQueryError = ErrorResponse


export function useGetApiDemoCodeDemoCode<TData = Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError = ErrorResponse>(
 demoCode: string,
    params: undefined |  GetApiDemoCodeDemoCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>,
          TError,
          Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDemoCodeDemoCode<TData = Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError = ErrorResponse>(
 demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>,
          TError,
          Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDemoCodeDemoCode<TData = Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError = ErrorResponse>(
 demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDemoCodeDemoCode<TData = Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError = ErrorResponse>(
 demoCode: string,
    params?: GetApiDemoCodeDemoCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDemoCodeDemoCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDemoCodeDemoCodeQueryOptions(demoCode,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiDemoCodeDemoCode = (
    demoCode: string,
    params?: DeleteApiDemoCodeDemoCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/demo/code/${demoCode}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiDemoCodeDemoCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>, TError,{demoCode: string;params?: DeleteApiDemoCodeDemoCodeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>, TError,{demoCode: string;params?: DeleteApiDemoCodeDemoCodeParams}, TContext> => {

const mutationKey = ['deleteApiDemoCodeDemoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>, {demoCode: string;params?: DeleteApiDemoCodeDemoCodeParams}> = (props) => {
          const {demoCode,params} = props ?? {};

          return  deleteApiDemoCodeDemoCode(demoCode,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiDemoCodeDemoCodeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>>

    export type DeleteApiDemoCodeDemoCodeMutationError = ErrorResponse

    export const useDeleteApiDemoCodeDemoCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>, TError,{demoCode: string;params?: DeleteApiDemoCodeDemoCodeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiDemoCodeDemoCode>>,
        TError,
        {demoCode: string;params?: DeleteApiDemoCodeDemoCodeParams},
        TContext
      > => {
      return useMutation(getDeleteApiDemoCodeDemoCodeMutationOptions(options), queryClient);
    }
    export const postApiVouchers = (
    createVoucherRequest?: CreateVoucherRequest,
    params?: PostApiVouchersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/vouchers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVoucherRequest,
        params, signal
    },
      );
    }




export const getPostApiVouchersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVouchers>>, TError,{data?: CreateVoucherRequest;params?: PostApiVouchersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiVouchers>>, TError,{data?: CreateVoucherRequest;params?: PostApiVouchersParams}, TContext> => {

const mutationKey = ['postApiVouchers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiVouchers>>, {data?: CreateVoucherRequest;params?: PostApiVouchersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiVouchers(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiVouchersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiVouchers>>>
    export type PostApiVouchersMutationBody = CreateVoucherRequest | undefined
    export type PostApiVouchersMutationError = ErrorResponse

    export const usePostApiVouchers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiVouchers>>, TError,{data?: CreateVoucherRequest;params?: PostApiVouchersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiVouchers>>,
        TError,
        {data?: CreateVoucherRequest;params?: PostApiVouchersParams},
        TContext
      > => {
      return useMutation(getPostApiVouchersMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const getApiAdministrationCompaniesCompanyIdWalletTypes = (
    companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletTypeResponse[]>(
      {url: `/api/administration/companies/${companyId}/wallet-types`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationCompaniesCompanyIdWalletTypesQueryKey = (companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams,) => {
    return [
    `/api/administration/companies/${companyId}/wallet-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationCompaniesCompanyIdWalletTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError = ErrorResponse>(companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationCompaniesCompanyIdWalletTypesQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>> = ({ signal }) => getApiAdministrationCompaniesCompanyIdWalletTypes(companyId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationCompaniesCompanyIdWalletTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>>
export type GetApiAdministrationCompaniesCompanyIdWalletTypesQueryError = ErrorResponse


export function useGetApiAdministrationCompaniesCompanyIdWalletTypes<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError = ErrorResponse>(
 companyId: number,
    params: undefined |  GetApiAdministrationCompaniesCompanyIdWalletTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdWalletTypes<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdWalletTypes<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiAdministrationCompaniesCompanyIdWalletTypes<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdWalletTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdWalletTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationCompaniesCompanyIdWalletTypesQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAdministrationEmployeeusersEmployeeUserIdWallets = (
    employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserWalletBalancesResponse[]>(
      {url: `/api/administration/employeeusers/${employeeUserId}/wallets`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryKey = (employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams,) => {
    return [
    `/api/administration/employeeusers/${employeeUserId}/wallets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError = ErrorResponse>(employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryKey(employeeUserId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>> = ({ signal }) => getApiAdministrationEmployeeusersEmployeeUserIdWallets(employeeUserId,params, signal);





   return  { queryKey, queryFn, enabled: employeeUserId !== null && employeeUserId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>>
export type GetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryError = ErrorResponse


export function useGetApiAdministrationEmployeeusersEmployeeUserIdWallets<TData = Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError = ErrorResponse>(
 employeeUserId: string,
    params: undefined |  GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationEmployeeusersEmployeeUserIdWallets<TData = Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError = ErrorResponse>(
 employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationEmployeeusersEmployeeUserIdWallets<TData = Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError = ErrorResponse>(
 employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationEmployeeusersEmployeeUserIdWallets<TData = Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError = ErrorResponse>(
 employeeUserId: string,
    params?: GetApiAdministrationEmployeeusersEmployeeUserIdWalletsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationEmployeeusersEmployeeUserIdWallets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationEmployeeusersEmployeeUserIdWalletsQueryOptions(employeeUserId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAdministrationWalletsWalletId = (
    walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletBalancesResponse>(
      {url: `/api/administration/wallets/${walletId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationWalletsWalletIdQueryKey = (walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams,) => {
    return [
    `/api/administration/wallets/${walletId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationWalletsWalletIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError = ErrorResponse>(walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationWalletsWalletIdQueryKey(walletId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>> = ({ signal }) => getApiAdministrationWalletsWalletId(walletId,params, signal);





   return  { queryKey, queryFn, enabled: walletId !== null && walletId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationWalletsWalletIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>>
export type GetApiAdministrationWalletsWalletIdQueryError = ErrorResponse


export function useGetApiAdministrationWalletsWalletId<TData = Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError = ErrorResponse>(
 walletId: string,
    params: undefined |  GetApiAdministrationWalletsWalletIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationWalletsWalletId<TData = Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationWalletsWalletId<TData = Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationWalletsWalletId<TData = Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiAdministrationWalletsWalletIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationWalletsWalletId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationWalletsWalletIdQueryOptions(walletId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout = (
    companyId: number,
    serviceModuleId: number,
    params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/companies/${companyId}/servicemodules/statussystem/${serviceModuleId}/payout`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>, {companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams}> = (props) => {
          const {companyId,serviceModuleId,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout(companyId,serviceModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>>

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutMutationError = ProblemDetails

    export const usePostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayout>>,
        TError,
        {companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdServicemodulesStatussystemServiceModuleIdPayoutMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate = (
    companyId: number,
    serviceModuleId: number,
    recalculateTimeQuotaModel?: RecalculateTimeQuotaModel,
    params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/companies/${companyId}/servicemodules/timetracking/${serviceModuleId}/timequota/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recalculateTimeQuotaModel,
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimeQuotaModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimeQuotaModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>, {companyId: number;serviceModuleId: number;data?: RecalculateTimeQuotaModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams}> = (props) => {
          const {companyId,serviceModuleId,data,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate(companyId,serviceModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>>
    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateMutationBody = RecalculateTimeQuotaModel | undefined
    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateMutationError = ProblemDetails

    export const usePostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimeQuotaModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculate>>,
        TError,
        {companyId: number;serviceModuleId: number;data?: RecalculateTimeQuotaModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide = (
    companyId: number,
    serviceModuleId: number,
    params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/companies/${companyId}/servicemodules/timetracking/${serviceModuleId}/timequota/calculate/companywide`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>, {companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams}> = (props) => {
          const {companyId,serviceModuleId,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide(companyId,serviceModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>>

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideMutationError = ProblemDetails

    export const usePostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>, TError,{companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywide>>,
        TError,
        {companyId: number;serviceModuleId: number;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimequotaCalculateCompanywideMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate = (
    companyId: number,
    serviceModuleId: number,
    recalculateTimetrackingModel?: RecalculateTimetrackingModel,
    params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/companies/${companyId}/servicemodules/timetracking/${serviceModuleId}/timetracking/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recalculateTimetrackingModel,
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimetrackingModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimetrackingModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>, {companyId: number;serviceModuleId: number;data?: RecalculateTimetrackingModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams}> = (props) => {
          const {companyId,serviceModuleId,data,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate(companyId,serviceModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>>
    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateMutationBody = RecalculateTimetrackingModel | undefined
    export type PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateMutationError = ProblemDetails

    export const usePostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>, TError,{companyId: number;serviceModuleId: number;data?: RecalculateTimetrackingModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculate>>,
        TError,
        {companyId: number;serviceModuleId: number;data?: RecalculateTimetrackingModel;params?: PostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdServicemodulesTimetrackingServiceModuleIdTimetrackingCalculateMutationOptions(options), queryClient);
    }
    export const deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword = (
    companyId: number,
    employeeId: string,
    params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/employees/${employeeId}/password`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>, TError,{companyId: number;employeeId: string;params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>, TError,{companyId: number;employeeId: string;params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams}, TContext> => {

const mutationKey = ['deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>, {companyId: number;employeeId: string;params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams}> = (props) => {
          const {companyId,employeeId,params} = props ?? {};

          return  deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword(companyId,employeeId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>>

    export type DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordMutationError = ErrorResponse

    export const useDeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>, TError,{companyId: number;employeeId: string;params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPassword>>,
        TError,
        {companyId: number;employeeId: string;params?: DeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordParams},
        TContext
      > => {
      return useMutation(getDeleteApiAdministratorusersCompaniesCompanyIdEmployeesEmployeeIdPasswordMutationOptions(options), queryClient);
    }
    export const patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords = (
    companyId: number,
    setEmployeeUserPasswordRequest?: SetEmployeeUserPasswordRequest[],
    params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/employees/passwords`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setEmployeeUserPasswordRequest,
        params, signal
    },
      );
    }




export const getPatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>, TError,{companyId: number;data?: SetEmployeeUserPasswordRequest[];params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>, TError,{companyId: number;data?: SetEmployeeUserPasswordRequest[];params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams}, TContext> => {

const mutationKey = ['patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>, {companyId: number;data?: SetEmployeeUserPasswordRequest[];params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams}> = (props) => {
          const {companyId,data,params} = props ?? {};

          return  patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords(companyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>>
    export type PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsMutationBody = SetEmployeeUserPasswordRequest[] | undefined
    export type PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsMutationError = ErrorResponse

    export const usePatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>, TError,{companyId: number;data?: SetEmployeeUserPasswordRequest[];params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAdministratorusersCompaniesCompanyIdEmployeesPasswords>>,
        TError,
        {companyId: number;data?: SetEmployeeUserPasswordRequest[];params?: PatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsParams},
        TContext
      > => {
      return useMutation(getPatchApiAdministratorusersCompaniesCompanyIdEmployeesPasswordsMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersCompaniesCompanyIdEmployeesGroups = (
    companyId: number,
    updateGroupAssignment?: UpdateGroupAssignment[],
    params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/employees/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupAssignment,
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>, TError,{companyId: number;data?: UpdateGroupAssignment[];params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>, TError,{companyId: number;data?: UpdateGroupAssignment[];params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersCompaniesCompanyIdEmployeesGroups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>, {companyId: number;data?: UpdateGroupAssignment[];params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams}> = (props) => {
          const {companyId,data,params} = props ?? {};

          return  postApiAdministratorusersCompaniesCompanyIdEmployeesGroups(companyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>>
    export type PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsMutationBody = UpdateGroupAssignment[] | undefined
    export type PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsMutationError = ErrorResponse

    export const usePostApiAdministratorusersCompaniesCompanyIdEmployeesGroups = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>, TError,{companyId: number;data?: UpdateGroupAssignment[];params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdEmployeesGroups>>,
        TError,
        {companyId: number;data?: UpdateGroupAssignment[];params?: PostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersCompaniesCompanyIdEmployeesGroupsMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail = (
    companyId: string,
    params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/invoices/vouchers/sendCompaniesBoughtVouchersSumEmail`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>, TError,{companyId: string;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>, TError,{companyId: string;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>, {companyId: string;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>>

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailMutationError = unknown

    export const usePostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>, TError,{companyId: string;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmail>>,
        TError,
        {companyId: string;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersCompaniesCompanyIdInvoicesVouchersSendCompaniesBoughtVouchersSumEmailMutationOptions(options), queryClient);
    }
    export const getApiAdministratorusersAnalysisfiles = (
    params: GetApiAdministratorusersAnalysisfilesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyAnalysisFileResponsePaginatedResponse>(
      {url: `/api/administratorusers/analysisfiles`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministratorusersAnalysisfilesQueryKey = (params?: GetApiAdministratorusersAnalysisfilesParams,) => {
    return [
    `/api/administratorusers/analysisfiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministratorusersAnalysisfilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError = ErrorResponse>(params: GetApiAdministratorusersAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministratorusersAnalysisfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>> = ({ signal }) => getApiAdministratorusersAnalysisfiles(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministratorusersAnalysisfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>>
export type GetApiAdministratorusersAnalysisfilesQueryError = ErrorResponse


export function useGetApiAdministratorusersAnalysisfiles<TData = Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersAnalysisfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministratorusersAnalysisfiles<TData = Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministratorusersAnalysisfiles<TData = Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministratorusersAnalysisfiles<TData = Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersAnalysisfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministratorusersAnalysisfilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId = (
    companyId: number,
    params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/upcomingbonusrewardsanalysisfiles/${companyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>, {companyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyId>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId = (
    companyId: number,
    subCompanyId: number,
    params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/upcomingbonusrewardsanalysisfiles/${companyId}/${subCompanyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>, {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams}> = (props) => {
          const {companyId,subCompanyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId(companyId,subCompanyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyId>>,
        TError,
        {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesUpcomingbonusrewardsanalysisfilesCompanyIdSubCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId = (
    companyId: number,
    params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/newemployeesanalysisfiles/${companyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>, {companyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyId>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId = (
    companyId: number,
    subCompanyId: number,
    params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/newemployeesanalysisfiles/${companyId}/${subCompanyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>, {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams}> = (props) => {
          const {companyId,subCompanyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId(companyId,subCompanyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyId>>,
        TError,
        {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesNewemployeesanalysisfilesCompanyIdSubCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId = (
    companyId: number,
    params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/directpayoutreport/${companyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>, {companyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyId>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId = (
    companyId: number,
    subCompanyId: number,
    params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/directpayoutreport/${companyId}/${subCompanyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>, {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams}> = (props) => {
          const {companyId,subCompanyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId(companyId,subCompanyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyId>>,
        TError,
        {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesDirectpayoutreportCompanyIdSubCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId = (
    companyId: number,
    params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/companypensionreport/${companyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>, {companyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>, TError,{companyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyId>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId = (
    companyId: number,
    subCompanyId: number,
    params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/analysisfiles/companypensionreport/${companyId}/${subCompanyId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>, {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams}> = (props) => {
          const {companyId,subCompanyId,params} = props ?? {};

          return  postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId(companyId,subCompanyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>>

    export type PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>, TError,{companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyId>>,
        TError,
        {companyId: number;subCompanyId: number;params?: PostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersAnalysisfilesCompanypensionreportCompanyIdSubCompanyIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesVoucheroverview = (
    params?: GetApiCompaniesVoucheroverviewParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyCadoozOverviewModel[]>(
      {url: `/api/companies/voucheroverview`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesVoucheroverviewQueryKey = (params?: GetApiCompaniesVoucheroverviewParams,) => {
    return [
    `/api/companies/voucheroverview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesVoucheroverviewQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError = unknown>(params?: GetApiCompaniesVoucheroverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesVoucheroverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>> = ({ signal }) => getApiCompaniesVoucheroverview(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesVoucheroverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>>
export type GetApiCompaniesVoucheroverviewQueryError = unknown


export function useGetApiCompaniesVoucheroverview<TData = Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError = unknown>(
 params: undefined |  GetApiCompaniesVoucheroverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesVoucheroverview<TData = Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError = unknown>(
 params?: GetApiCompaniesVoucheroverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesVoucheroverview<TData = Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError = unknown>(
 params?: GetApiCompaniesVoucheroverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesVoucheroverview<TData = Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError = unknown>(
 params?: GetApiCompaniesVoucheroverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesVoucheroverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesVoucheroverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompanies = (
    createCompanyRequest?: CreateCompanyRequest,
    params?: PostApiCompaniesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyResponse>(
      {url: `/api/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompanies>>, TError,{data?: CreateCompanyRequest;params?: PostApiCompaniesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompanies>>, TError,{data?: CreateCompanyRequest;params?: PostApiCompaniesParams}, TContext> => {

const mutationKey = ['postApiCompanies'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompanies>>, {data?: CreateCompanyRequest;params?: PostApiCompaniesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCompanies(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompanies>>>
    export type PostApiCompaniesMutationBody = CreateCompanyRequest | undefined
    export type PostApiCompaniesMutationError = ErrorResponse

    export const usePostApiCompanies = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompanies>>, TError,{data?: CreateCompanyRequest;params?: PostApiCompaniesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompanies>>,
        TError,
        {data?: CreateCompanyRequest;params?: PostApiCompaniesParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesMutationOptions(options), queryClient);
    }
    export const getApiCompanies = (
    params?: GetApiCompaniesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyResponse[]>(
      {url: `/api/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesQueryKey = (params?: GetApiCompaniesParams,) => {
    return [
    `/api/companies`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompanies>>, TError = ErrorResponse>(params?: GetApiCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompanies>>> = ({ signal }) => getApiCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompanies>>>
export type GetApiCompaniesQueryError = ErrorResponse


export function useGetApiCompanies<TData = Awaited<ReturnType<typeof getApiCompanies>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiCompanies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompanies<TData = Awaited<ReturnType<typeof getApiCompanies>>, TError = ErrorResponse>(
 params?: GetApiCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiCompanies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompanies<TData = Awaited<ReturnType<typeof getApiCompanies>>, TError = ErrorResponse>(
 params?: GetApiCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompanies<TData = Awaited<ReturnType<typeof getApiCompanies>>, TError = ErrorResponse>(
 params?: GetApiCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesPaginated = (
    params: GetApiCompaniesPaginatedParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyListItemResponsePaginatedResponse>(
      {url: `/api/companies/paginated`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesPaginatedQueryKey = (params?: GetApiCompaniesPaginatedParams,) => {
    return [
    `/api/companies/paginated`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError = ErrorResponse>(params: GetApiCompaniesPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesPaginatedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesPaginated>>> = ({ signal }) => getApiCompaniesPaginated(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesPaginated>>>
export type GetApiCompaniesPaginatedQueryError = ErrorResponse


export function useGetApiCompaniesPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError = ErrorResponse>(
 params: GetApiCompaniesPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesPaginated>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesPaginated>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError = ErrorResponse>(
 params: GetApiCompaniesPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesPaginated>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesPaginated>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError = ErrorResponse>(
 params: GetApiCompaniesPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError = ErrorResponse>(
 params: GetApiCompaniesPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesPaginated>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCompanyId = (
    companyId: number,
    params?: GetApiCompaniesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyResponse>(
      {url: `/api/companies/${companyId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdQueryKey = (companyId: number,
    params?: GetApiCompaniesCompanyIdParams,) => {
    return [
    `/api/companies/${companyId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError = ErrorResponse>(companyId: number,
    params?: GetApiCompaniesCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>> = ({ signal }) => getApiCompaniesCompanyId(companyId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>>
export type GetApiCompaniesCompanyIdQueryError = ErrorResponse


export function useGetApiCompaniesCompanyId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError = ErrorResponse>(
 companyId: number,
    params: undefined |  GetApiCompaniesCompanyIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCompanyId = (
    companyId: number,
    updateCompanyRequest?: UpdateCompanyRequest,
    params?: PatchApiCompaniesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyResponse>(
      {url: `/api/companies/${companyId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyRequest,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>, TError,{companyId: number;data?: UpdateCompanyRequest;params?: PatchApiCompaniesCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>, TError,{companyId: number;data?: UpdateCompanyRequest;params?: PatchApiCompaniesCompanyIdParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>, {companyId: number;data?: UpdateCompanyRequest;params?: PatchApiCompaniesCompanyIdParams}> = (props) => {
          const {companyId,data,params} = props ?? {};

          return  patchApiCompaniesCompanyId(companyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>>
    export type PatchApiCompaniesCompanyIdMutationBody = UpdateCompanyRequest | undefined
    export type PatchApiCompaniesCompanyIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>, TError,{companyId: number;data?: UpdateCompanyRequest;params?: PatchApiCompaniesCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCompanyId>>,
        TError,
        {companyId: number;data?: UpdateCompanyRequest;params?: PatchApiCompaniesCompanyIdParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCompanyIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCompanyId = (
    companyId: number,
    params?: DeleteApiCompaniesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>, {companyId: number;params?: DeleteApiCompaniesCompanyIdParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  deleteApiCompaniesCompanyId(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>>

    export type DeleteApiCompaniesCompanyIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCompanyId>>,
        TError,
        {companyId: number;params?: DeleteApiCompaniesCompanyIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersInvoicesCompaniesCompanyId = (
    companyId: number,
    invoiceCreationRequest?: InvoiceCreationRequest,
    params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<InvoiceFileModel>(
      {url: `/api/administratorusers/invoices/companies/${companyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoiceCreationRequest,
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersInvoicesCompaniesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>, TError,{companyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>, TError,{companyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersInvoicesCompaniesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>, {companyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams}> = (props) => {
          const {companyId,data,params} = props ?? {};

          return  postApiAdministratorusersInvoicesCompaniesCompanyId(companyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>>
    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdMutationBody = InvoiceCreationRequest | undefined
    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersInvoicesCompaniesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>, TError,{companyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyId>>,
        TError,
        {companyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersInvoicesCompaniesCompanyIdMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId = (
    companyId: number,
    subCompanyId: number,
    invoiceCreationRequest?: InvoiceCreationRequest,
    params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<InvoiceFileModel>(
      {url: `/api/administratorusers/invoices/companies/${companyId}/subCompanies/${subCompanyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoiceCreationRequest,
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>, TError,{companyId: number;subCompanyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>, TError,{companyId: number;subCompanyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>, {companyId: number;subCompanyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams}> = (props) => {
          const {companyId,subCompanyId,data,params} = props ?? {};

          return  postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId(companyId,subCompanyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>>
    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdMutationBody = InvoiceCreationRequest | undefined
    export type PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdMutationError = ErrorResponse

    export const usePostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>, TError,{companyId: number;subCompanyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyId>>,
        TError,
        {companyId: number;subCompanyId: number;data?: InvoiceCreationRequest;params?: PostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersInvoicesCompaniesCompanyIdSubCompaniesSubCompanyIdMutationOptions(options), queryClient);
    }
    export const getApiAdministratorusersInvoices = (
    params: GetApiAdministratorusersInvoicesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyInvoiceFileResponsePaginatedResponse>(
      {url: `/api/administratorusers/invoices`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministratorusersInvoicesQueryKey = (params?: GetApiAdministratorusersInvoicesParams,) => {
    return [
    `/api/administratorusers/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministratorusersInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError = ErrorResponse>(params: GetApiAdministratorusersInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministratorusersInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>> = ({ signal }) => getApiAdministratorusersInvoices(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministratorusersInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>>
export type GetApiAdministratorusersInvoicesQueryError = ErrorResponse


export function useGetApiAdministratorusersInvoices<TData = Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministratorusersInvoices<TData = Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministratorusersInvoices<TData = Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministratorusersInvoices<TData = Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError = ErrorResponse>(
 params: GetApiAdministratorusersInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministratorusersInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministratorusersInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCompanyIdMembers = (
    companyId: number,
    params?: PostApiCompaniesCompanyIdMembersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/members`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdMembersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: PostApiCompaniesCompanyIdMembersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: PostApiCompaniesCompanyIdMembersParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdMembers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>, {companyId: number;params?: PostApiCompaniesCompanyIdMembersParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiCompaniesCompanyIdMembers(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdMembersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>>

    export type PostApiCompaniesCompanyIdMembersMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdMembers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: PostApiCompaniesCompanyIdMembersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdMembers>>,
        TError,
        {companyId: number;params?: PostApiCompaniesCompanyIdMembersParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdMembersMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCompanyIdMembers = (
    companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<UserResponse[]>(
      {url: `/api/companies/${companyId}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdMembersQueryKey = (companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams,) => {
    return [
    `/api/companies/${companyId}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError = ErrorResponse>(companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdMembersQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>> = ({ signal }) => getApiCompaniesCompanyIdMembers(companyId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>>
export type GetApiCompaniesCompanyIdMembersQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError = ErrorResponse>(
 companyId: number,
    params: undefined |  GetApiCompaniesCompanyIdMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiCompaniesCompanyIdMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdMembersQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCompaniesCompanyIdMembers = (
    companyId: number,
    params?: DeleteApiCompaniesCompanyIdMembersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/members`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCompanyIdMembersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdMembersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdMembersParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCompanyIdMembers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>, {companyId: number;params?: DeleteApiCompaniesCompanyIdMembersParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  deleteApiCompaniesCompanyIdMembers(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCompanyIdMembersMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>>

    export type DeleteApiCompaniesCompanyIdMembersMutationError = ErrorResponse

    export const useDeleteApiCompaniesCompanyIdMembers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>, TError,{companyId: number;params?: DeleteApiCompaniesCompanyIdMembersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdMembers>>,
        TError,
        {companyId: number;params?: DeleteApiCompaniesCompanyIdMembersParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCompanyIdMembersMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdVoucherorder = (
    companyId: number,
    params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams,
 signal?: AbortSignal
) => {


      return axiosInstance<OrderVouchersResult[]>(
      {url: `/api/administration/companies/${companyId}/voucherorder`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdVoucherorderMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>, TError,{companyId: number;params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>, TError,{companyId: number;params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdVoucherorder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>, {companyId: number;params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdVoucherorder(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdVoucherorderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>>

    export type PostApiAdministrationCompaniesCompanyIdVoucherorderMutationError = ErrorResponse

    export const usePostApiAdministrationCompaniesCompanyIdVoucherorder = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>, TError,{companyId: number;params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorder>>,
        TError,
        {companyId: number;params: PostApiAdministrationCompaniesCompanyIdVoucherorderParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdVoucherorderMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType = (
    companyId: number,
    shopModuleType: ShopModuleType,
    params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<OrderVouchersResult>(
      {url: `/api/administration/companies/${companyId}/voucherorder/${shopModuleType}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>, TError,{companyId: number;shopModuleType: ShopModuleType;params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>, TError,{companyId: number;shopModuleType: ShopModuleType;params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>, {companyId: number;shopModuleType: ShopModuleType;params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams}> = (props) => {
          const {companyId,shopModuleType,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType(companyId,shopModuleType,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>>

    export type PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeMutationError = ErrorResponse

    export const usePostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>, TError,{companyId: number;shopModuleType: ShopModuleType;params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdVoucherorderShopModuleType>>,
        TError,
        {companyId: number;shopModuleType: ShopModuleType;params: PostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdVoucherorderShopModuleTypeMutationOptions(options), queryClient);
    }
    export const postApiAdministrationCompaniesCompanyIdActionmodulesSeeding = (
    companyId: number,
    params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administration/companies/${companyId}/actionmodules/seeding`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdActionmodulesSeedingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>, TError,{companyId: number;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>, TError,{companyId: number;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdActionmodulesSeeding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>, {companyId: number;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdActionmodulesSeeding(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>>

    export type PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingMutationError = unknown

    export const usePostApiAdministrationCompaniesCompanyIdActionmodulesSeeding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>, TError,{companyId: number;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodulesSeeding>>,
        TError,
        {companyId: number;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesSeedingParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdActionmodulesSeedingMutationOptions(options), queryClient);
    }
    export const getApiAdministrationCompaniesCompanyIdActionmodules = (
    companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse[]>(
      {url: `/api/administration/companies/${companyId}/actionmodules`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationCompaniesCompanyIdActionmodulesQueryKey = (companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams,) => {
    return [
    `/api/administration/companies/${companyId}/actionmodules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationCompaniesCompanyIdActionmodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError = ErrorResponse>(companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationCompaniesCompanyIdActionmodulesQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>> = ({ signal }) => getApiAdministrationCompaniesCompanyIdActionmodules(companyId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationCompaniesCompanyIdActionmodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>>
export type GetApiAdministrationCompaniesCompanyIdActionmodulesQueryError = ErrorResponse


export function useGetApiAdministrationCompaniesCompanyIdActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError = ErrorResponse>(
 companyId: number,
    params: undefined |  GetApiAdministrationCompaniesCompanyIdActionmodulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationCompaniesCompanyIdActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError = ErrorResponse>(
 companyId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationCompaniesCompanyIdActionmodulesQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministrationCompaniesCompanyIdActionmodules = (
    companyId: number,
    createActionModuleRequest?: NonReadonly<CreateActionModuleRequest>,
    params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/administration/companies/${companyId}/actionmodules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActionModuleRequest,
        params, signal
    },
      );
    }




export const getPostApiAdministrationCompaniesCompanyIdActionmodulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>, TError,{companyId: number;data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>, TError,{companyId: number;data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams}, TContext> => {

const mutationKey = ['postApiAdministrationCompaniesCompanyIdActionmodules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>, {companyId: number;data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams}> = (props) => {
          const {companyId,data,params} = props ?? {};

          return  postApiAdministrationCompaniesCompanyIdActionmodules(companyId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministrationCompaniesCompanyIdActionmodulesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>>
    export type PostApiAdministrationCompaniesCompanyIdActionmodulesMutationBody = NonReadonly<CreateActionModuleRequest> | undefined
    export type PostApiAdministrationCompaniesCompanyIdActionmodulesMutationError = ErrorResponse

    export const usePostApiAdministrationCompaniesCompanyIdActionmodules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>, TError,{companyId: number;data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministrationCompaniesCompanyIdActionmodules>>,
        TError,
        {companyId: number;data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiAdministrationCompaniesCompanyIdActionmodulesParams},
        TContext
      > => {
      return useMutation(getPostApiAdministrationCompaniesCompanyIdActionmodulesMutationOptions(options), queryClient);
    }
    export const getApiAdministrationActionmodules = (
    params: GetApiAdministrationActionmodulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleAdminResponsePaginatedResponse>(
      {url: `/api/administration/actionmodules`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationActionmodulesQueryKey = (params?: GetApiAdministrationActionmodulesParams,) => {
    return [
    `/api/administration/actionmodules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationActionmodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError = ErrorResponse>(params: GetApiAdministrationActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationActionmodulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>> = ({ signal }) => getApiAdministrationActionmodules(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationActionmodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>>
export type GetApiAdministrationActionmodulesQueryError = ErrorResponse


export function useGetApiAdministrationActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError = ErrorResponse>(
 params: GetApiAdministrationActionmodulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError = ErrorResponse>(
 params: GetApiAdministrationActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError = ErrorResponse>(
 params: GetApiAdministrationActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationActionmodules<TData = Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError = ErrorResponse>(
 params: GetApiAdministrationActionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationActionmodulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId = (
    companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/administration/companies/${companyId}/actionmodules/${actionModuleId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryKey = (companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,) => {
    return [
    `/api/administration/companies/${companyId}/actionmodules/${actionModuleId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryKey(companyId,actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>> = ({ signal }) => getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId(companyId,actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>>
export type GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryError = ErrorResponse


export function useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params: undefined |  GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdQueryOptions(companyId,actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId = (
    companyId: number,
    actionModuleId: number,
    updateActionModuleRequest?: NonReadonly<UpdateActionModuleRequest>,
    params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/administration/companies/${companyId}/actionmodules/${actionModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActionModuleRequest,
        params, signal
    },
      );
    }




export const getPatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext> => {

const mutationKey = ['patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, {companyId: number;actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>>
    export type PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationBody = NonReadonly<UpdateActionModuleRequest> | undefined
    export type PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationError = ErrorResponse

    export const usePatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>,
        TError,
        {companyId: number;actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams},
        TContext
      > => {
      return useMutation(getPatchApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationOptions(options), queryClient);
    }
    export const deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId = (
    companyId: number,
    actionModuleId: number,
    params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/administration/companies/${companyId}/actionmodules/${actionModuleId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext> => {

const mutationKey = ['deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, {companyId: number;actionModuleId: number;params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}> = (props) => {
          const {companyId,actionModuleId,params} = props ?? {};

          return  deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId(companyId,actionModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>>

    export type DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationError = ErrorResponse

    export const useDeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>, TError,{companyId: number;actionModuleId: number;params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId>>,
        TError,
        {companyId: number;actionModuleId: number;params?: DeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiAdministrationCompaniesCompanyIdActionmodulesActionModuleIdMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh = (
    companyId: number,
    actionModuleId: number,
    params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams,
 signal?: AbortSignal
) => {


      return axiosInstance<boolean>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/refresh`, method: 'PATCH',
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>, TError,{companyId: number;actionModuleId: number;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>, TError,{companyId: number;actionModuleId: number;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>, {companyId: number;actionModuleId: number;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams}> = (props) => {
          const {companyId,actionModuleId,params} = props ?? {};

          return  patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh(companyId,actionModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>>

    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshMutationError = ErrorResponse

    export const usePatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>, TError,{companyId: number;actionModuleId: number;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefresh>>,
        TError,
        {companyId: number;actionModuleId: number;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersRefreshMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck = (
    companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams,
 signal?: AbortSignal
) => {


      return axiosInstance<boolean>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/check`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryKey = (companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/check`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryKey(companyId,actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck(companyId,actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersCheckQueryOptions(companyId,actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers = (
    companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleNotificationBaseTriggerModel[]>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryKey = (companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryKey(companyId,actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers(companyId,actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersQueryOptions(companyId,actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId = (
    companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/${notificationTriggerId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>, {companyId: number;actionModuleId: number;notificationTriggerId: number;params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams}> = (props) => {
          const {companyId,actionModuleId,notificationTriggerId,params} = props ?? {};

          return  deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId(companyId,actionModuleId,notificationTriggerId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>>

    export type DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerId>>,
        TError,
        {companyId: number;actionModuleId: number;notificationTriggerId: number;params?: DeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersNotificationTriggerIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId = (
    companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleNotificationGenericMessageTriggerModel>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/genericMessage/${notificationTriggerId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryKey = (companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/genericMessage/${notificationTriggerId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryKey(companyId,actionModuleId,notificationTriggerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId(companyId,actionModuleId,notificationTriggerId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined && notificationTriggerId !== null && notificationTriggerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdQueryOptions(companyId,actionModuleId,notificationTriggerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId = (
    companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    actionModuleNotificationGenericMessageTriggerModel?: ActionModuleNotificationGenericMessageTriggerModel,
    params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/genericMessage/${notificationTriggerId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: actionModuleNotificationGenericMessageTriggerModel,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, {companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams}> = (props) => {
          const {companyId,actionModuleId,notificationTriggerId,data,params} = props ?? {};

          return  patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId(companyId,actionModuleId,notificationTriggerId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>>
    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdMutationBody = ActionModuleNotificationGenericMessageTriggerModel | undefined
    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerId>>,
        TError,
        {companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageNotificationTriggerIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage = (
    companyId: number,
    actionModuleId: number,
    actionModuleNotificationGenericMessageTriggerModel?: ActionModuleNotificationGenericMessageTriggerModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/genericMessage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionModuleNotificationGenericMessageTriggerModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>, {companyId: number;actionModuleId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageMutationBody = ActionModuleNotificationGenericMessageTriggerModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessage>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ActionModuleNotificationGenericMessageTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersGenericMessageMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId = (
    companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleNotificationNotifyTriggerModel>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/actionModuleInstanceNotify/${notificationTriggerId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryKey = (companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/actionModuleInstanceNotify/${notificationTriggerId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryKey(companyId,actionModuleId,notificationTriggerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId(companyId,actionModuleId,notificationTriggerId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined && notificationTriggerId !== null && notificationTriggerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdQueryOptions(companyId,actionModuleId,notificationTriggerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId = (
    companyId: number,
    actionModuleId: number,
    notificationTriggerId: number,
    actionModuleNotificationNotifyTriggerModel?: ActionModuleNotificationNotifyTriggerModel,
    params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/actionModuleInstanceNotify/${notificationTriggerId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: actionModuleNotificationNotifyTriggerModel,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, {companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams}> = (props) => {
          const {companyId,actionModuleId,notificationTriggerId,data,params} = props ?? {};

          return  patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId(companyId,actionModuleId,notificationTriggerId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>>
    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdMutationBody = ActionModuleNotificationNotifyTriggerModel | undefined
    export type PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>, TError,{companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerId>>,
        TError,
        {companyId: number;actionModuleId: number;notificationTriggerId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyNotificationTriggerIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify = (
    companyId: number,
    actionModuleId: number,
    actionModuleNotificationNotifyTriggerModel?: ActionModuleNotificationNotifyTriggerModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/notificationtriggers/actionModuleInstanceNotify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionModuleNotificationNotifyTriggerModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>, {companyId: number;actionModuleId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyMutationBody = ActionModuleNotificationNotifyTriggerModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>, TError,{companyId: number;actionModuleId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotify>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ActionModuleNotificationNotifyTriggerModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdNotificationtriggersActionModuleInstanceNotifyMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck = (
    companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams,
 signal?: AbortSignal
) => {


      return axiosInstance<boolean>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/check`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryKey = (companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/check`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryKey(companyId,actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck(companyId,actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleCheckQueryOptions(companyId,actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition = (
    companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ScheduleDefinitionBaseModel | ScheduleDaysDefinitionModel | ScheduleMonthDefinitionModel | ScheduleQuarterDefinitionModel | ScheduleTimePeriodsDefinitionModel | ScheduleWeekDefinitionModel>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryKey = (companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams,) => {
    return [
    `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError = ErrorResponse>(companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryKey(companyId,actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>> = ({ signal }) => getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition(companyId,actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>>
export type GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryError = ErrorResponse


export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params: undefined |  GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition<TData = Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError = ErrorResponse>(
 companyId: number,
    actionModuleId: number,
    params?: GetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinition>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQueryOptions(companyId,actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter = (
    companyId: number,
    actionModuleId: number,
    scheduleQuarterDefinitionModel?: ScheduleQuarterDefinitionModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/quarter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleQuarterDefinitionModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleQuarterDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleQuarterDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>, {companyId: number;actionModuleId: number;data?: ScheduleQuarterDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterMutationBody = ScheduleQuarterDefinitionModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleQuarterDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarter>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ScheduleQuarterDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionQuarterMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule = (
    companyId: number,
    actionModuleId: number,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/reschedule`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>, TError,{companyId: number;actionModuleId: number;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>, TError,{companyId: number;actionModuleId: number;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>, {companyId: number;actionModuleId: number;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams}> = (props) => {
          const {companyId,actionModuleId,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule(companyId,actionModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>>

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>, TError,{companyId: number;actionModuleId: number;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleReschedule>>,
        TError,
        {companyId: number;actionModuleId: number;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleRescheduleMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth = (
    companyId: number,
    actionModuleId: number,
    scheduleMonthDefinitionModel?: ScheduleMonthDefinitionModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/month`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleMonthDefinitionModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>, {companyId: number;actionModuleId: number;data?: ScheduleMonthDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthMutationBody = ScheduleMonthDefinitionModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonth>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ScheduleMonthDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek = (
    companyId: number,
    actionModuleId: number,
    scheduleWeekDefinitionModel?: ScheduleWeekDefinitionModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/week`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleWeekDefinitionModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleWeekDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleWeekDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>, {companyId: number;actionModuleId: number;data?: ScheduleWeekDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekMutationBody = ScheduleWeekDefinitionModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleWeekDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeek>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ScheduleWeekDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionWeekMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays = (
    companyId: number,
    actionModuleId: number,
    scheduleDaysDefinitionModel?: ScheduleDaysDefinitionModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/days`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleDaysDefinitionModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleDaysDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleDaysDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>, {companyId: number;actionModuleId: number;data?: ScheduleDaysDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysMutationBody = ScheduleDaysDefinitionModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleDaysDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDays>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ScheduleDaysDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDaysMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange = (
    companyId: number,
    actionModuleId: number,
    scheduleMonthDayRangeDefinitionModel?: ScheduleMonthDayRangeDefinitionModel,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/monthdayrange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleMonthDayRangeDefinitionModel,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDayRangeDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDayRangeDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>, {companyId: number;actionModuleId: number;data?: ScheduleMonthDayRangeDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeMutationBody = ScheduleMonthDayRangeDefinitionModel | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeMutationError = ErrorResponse

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>, TError,{companyId: number;actionModuleId: number;data?: ScheduleMonthDayRangeDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrange>>,
        TError,
        {companyId: number;actionModuleId: number;data?: ScheduleMonthDayRangeDefinitionModel;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionMonthdayrangeMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration = (
    companyId: number,
    actionModuleId: number,
    duration?: Duration,
    params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/${companyId}/actionmodules/${actionModuleId}/schedule/definition/duration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: duration,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>, TError,{companyId: number;actionModuleId: number;data?: Duration;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>, TError,{companyId: number;actionModuleId: number;data?: Duration;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams}, TContext> => {

const mutationKey = ['postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>, {companyId: number;actionModuleId: number;data?: Duration;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams}> = (props) => {
          const {companyId,actionModuleId,data,params} = props ?? {};

          return  postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration(companyId,actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>>
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationMutationBody = Duration | undefined
    export type PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationMutationError = ProblemDetails

    export const usePostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>, TError,{companyId: number;actionModuleId: number;data?: Duration;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDuration>>,
        TError,
        {companyId: number;actionModuleId: number;data?: Duration;params?: PostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCompanyIdActionmodulesActionModuleIdScheduleDefinitionDurationMutationOptions(options), queryClient);
    }
